var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "layer-item-container" }, [
    _c(
      "div",
      { staticClass: "layer-item__info" },
      [
        _c(_setup.LayerItemIcon, {
          staticClass: "layer-item__icon",
          attrs: { loading: _setup.loading, item: { item: _vm.item } },
        }),
        _c(
          "span",
          {
            staticClass: "layer-item__title",
            attrs: { title: _vm.item.name },
            on: {
              click: function ($event) {
                return _setup.emit("click", _vm.item)
              },
            },
          },
          [_c("span", [_vm._v(_vm._s(_vm.item.name))])]
        ),
        _c("div", { staticClass: "v-spacer" }),
        _c(
          "div",
          { staticClass: "layer-item__title-action" },
          [
            _vm._t("pre-btn", null, { loading: _setup.loading }),
            _vm.item.metadata.bounds
              ? _c(
                  "button",
                  {
                    staticClass: "layer-item__button",
                    attrs: { disabled: _setup.loading },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _setup.onToBounds.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(_setup.SvgIcon, {
                      attrs: {
                        size: "14",
                        type: "mdi",
                        path: _setup.path.flyTo,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "button",
              {
                staticClass: "layer-item__button",
                attrs: { disabled: _setup.loading },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _setup.toggleShow.apply(null, arguments)
                  },
                },
              },
              [
                _setup.isShow
                  ? _c(_setup.SvgIcon, {
                      attrs: {
                        size: "14",
                        type: "mdi",
                        path: _setup.path.show,
                      },
                    })
                  : _c(_setup.SvgIcon, {
                      attrs: {
                        size: "14",
                        type: "mdi",
                        path: _setup.path.hide,
                      },
                    }),
              ],
              1
            ),
            !_vm.item.config.disable_delete
              ? _c(
                  "button",
                  {
                    staticClass: "layer-item__button",
                    attrs: { disabled: _setup.loading },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _setup.onRemove.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(_setup.SvgIcon, {
                      attrs: {
                        size: "14",
                        type: "mdi",
                        path: _setup.path.delete,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._t("extra-btn", null, { loading: _setup.loading }),
            _vm.item.config.disabled_opacity && _setup.isHasLegend
              ? _c(
                  "button",
                  {
                    staticClass: "layer-item__button",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _setup.onToggleLegend.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(_setup.SvgIcon, {
                      attrs: {
                        size: "14",
                        type: "mdi",
                        path: _setup.legendShow
                          ? _setup.path.legendClose
                          : _setup.path.legendOpen,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          2
        ),
      ],
      1
    ),
    !_vm.item.config.disabled_opacity
      ? _c("div", { staticClass: "layer-item__action" }, [
          !_vm.item.config.disabled_opacity
            ? _c(
                "div",
                { staticClass: "layer-item__opacity" },
                [
                  _c(_setup.LayerItemSlider, {
                    attrs: { max: "1", step: "0.01", disabled: _setup.loading },
                    model: {
                      value: _setup.opacity,
                      callback: function ($$v) {
                        _setup.opacity = _vm._n($$v)
                      },
                      expression: "opacity",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "v-spacer" }),
          _setup.isHasLegend
            ? _c(
                "button",
                {
                  staticClass: "layer-item__button",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _setup.onToggleLegend.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(_setup.SvgIcon, {
                    attrs: {
                      size: "14",
                      type: "mdi",
                      path: _setup.legendShow
                        ? _setup.path.legendClose
                        : _setup.path.legendOpen,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _setup.legendShow && _setup.legendConfig
      ? _c(
          "div",
          _vm._l(_setup.legendConfig.items, function (item, i) {
            return _c(_setup.legendConfig.component, {
              key: i,
              tag: "component",
              attrs: { value: item },
            })
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }